import script from "./MyVouchersByMerchantPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyVouchersByMerchantPage.vue?vue&type=script&setup=true&lang=ts"

import "./MyVouchersByMerchantPage.vue?vue&type=style&index=0&id=2bee09d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bee09d4"]])

export default __exports__